import Lottie from 'react-lottie-player';
import { WeaveRewindPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';

type Props = {
  animation: any;
  isPaused: boolean;
  key: number | string;
  lottieRef: React.RefObject<any>;
  onPlayOrPause: () => void;
  onNextAnimation: () => void;
};

export const WeaveRewindAnimation = ({
  animation,
  isPaused,
  key,
  lottieRef,
  onPlayOrPause,
  onNextAnimation,
}: Props) => {
  return (
    <div
      onClick={onPlayOrPause}
      className='weave-rewind-animation'
      css={{
        cursor: 'pointer',
        position: 'relative',
        height: '100%',
      }}
      data-trackingid={WeaveRewindPrefixes.Modal + '-animation-container'}
    >
      <Lottie
        key={key}
        ref={lottieRef}
        animationData={animation}
        loop={false}
        play={!isPaused}
        onComplete={onNextAnimation}
        style={{
          height: 700,
          paddingTop: theme.spacing(3),
        }}
      />
      {/* Pause/Play overlay indicator */}
      {isPaused && (
        <div
          css={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0, 0, 0, 0.5)',
            borderRadius: theme.borderRadius.full,
            width: 80,
            height: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          <div
            css={{
              width: 0,
              height: 0,
              borderTop: '20px solid transparent',
              borderBottom: '20px solid transparent',
              borderLeft: '30px solid white',
              marginLeft: '5px',
            }}
          />
        </div>
      )}
    </div>
  );
};
